import React, { useEffect, useRef } from 'react';
import { HStack, VStack, Text, IconButton } from '@cad-arc';
import { FlagRenderer } from '../../../common/components/flag-renderer/flag-renderer';

export function DeleteNarrativeConfirmation({
    messageText,
    isLoading = false,
    onConfirm,
    onClose,
}: {
    messageText: string;
    isLoading?: boolean;
    onConfirm: () => void;
    onClose: () => void;
}): React.JSX.Element {
    const cancelRef = useRef<HTMLButtonElement>(null);

    useEffect(function autoFocusCancelButton() {
        cancelRef.current?.focus();
    }, []);

    return (
        <HStack
            bg="negative.default"
            borderRadius="base"
            px="6"
            py="3"
            w="100%"
            spacing="3"
            align="start"
            data-testid="DELETE_NARRATIVE_CONFIRMATION"
        >
            <VStack flex="1" minW="0" align="stretch" spacing="2" justify="center">
                <Text
                    fontSize="sm"
                    fontWeight="bold"
                    style={{ color: 'var(--arc-colors-negative-content)' }}
                >
                    Delete narrative message?
                </Text>
                <Text
                    as="div"
                    fontSize="sm"
                    style={{
                        color: 'var(--arc-colors-negative-content)',
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word',
                    }}
                >
                    <FlagRenderer text={messageText} />
                </Text>
            </VStack>
            <HStack spacing="1" align="center">
                <IconButton
                    ref={cancelRef}
                    aria-label="Cancel"
                    icon="CloseX"
                    variant="outline"
                    colorVariant="inverse"
                    disabled={isLoading}
                    onClick={onClose}
                />
                <IconButton
                    aria-label="Delete"
                    icon="Check"
                    variant="solid"
                    colorVariant="inverse"
                    isLoading={isLoading}
                    onClick={onConfirm}
                />
            </HStack>
        </HStack>
    );
}
